import { Injectable } from '@angular/core';
import { bancos } from '../../../utils/constants.utils';

@Injectable({
  providedIn: 'root'
})
export class BankNameService {


  constructor() { }

    /**
   * Função para converter o número do banco em seu nome correspondente.
   * @param bankNumber - O número do banco a ser convertido.
   * @returns O nome do banco correspondente ou uma mensagem de erro.
   */
    getBankName(bankNumber: string): string {

      const bank = bancos.find(b => b.optValue.startsWith(bankNumber));


      if (bank) {
        return this.removeBankNumber(bank.optLabel);
      }
      return 'Banco não encontrado';
    }

    /**
     * Função para remover o número e o hífen do início da string.
     * @param bankName - O nome do banco que pode conter um número no início.
     * @returns O nome do banco sem o número inicial.
     */
    private removeBankNumber(bankName: string): string {
      return bankName.replace(/^\d+-\s*/, '');
    }
}
